import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { OrderTextBox } from '../OrderTextBox'
import orderService from '../OrderService';
import { BaseTextArea } from '../../controls/BaseTextArea';
import { BaseTextBox } from '../../controls/BaseTextBox';
import { LeftRightOption } from '../../infrastructure/AppConstants';


export class HearingLossDataStepView extends Component {
    static displayName = HearingLossDataStepView.name;
    constructor(props) {
        super(props);
        var data = props.data;
        var left = [0, 0, 0, 0, 0, 0, 0, 0];
        var right = [0, 0, 0, 0, 0, 0, 0, 0];
        if (data) {
            var array = data.split(';');
            if (array.length === 2) {
                left = array[0].split(',');
                right = array[1].split(',');
            }
        }
        this.state = { left: left, right: right, specialRequirements: props.specialRequirements, leftRightOption: this.props.leftRightOption };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleTestAreaChange = this.handleTestAreaChange.bind(this);
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;
        var array = name.split('-');
        if (array.length === 2) {
            if (array[0] === 'left') {

                var index = parseInt(array[1]);
                this.state.left[index] = value;
                this.setState(
                    {
                        left: this.state.left.slice()

                    });

            }
            else if (array[0] === 'right') {
                var index = parseInt(array[1]);
                this.state.right[index] = value;
                this.setState(
                    {
                        right: this.state.right.slice()

                    });
            }
        }
    }

    handleTestAreaChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;
        this.setState({
            [name]: value
        });
    }

    componentDidMount() {
        this._subscription = orderService.subscribe(() => this.orderCommitting());
        this.props.onRef(this);
    }

    orderCommitting() {
        orderService.updateHearingLossData(this.state);
    }

    componentWillUnmount() {
        orderService.unsubscribe(this._subscription);
    }

    validate() {
        if (this.state.leftRightOption === LeftRightOption.LeftEarOption) {
            if (!this.idValidData(this.state.left[2]) ||
                !this.idValidData(this.state.left[3]) ||
                !this.idValidData(this.state.left[4]) ||
                !this.idValidData(this.state.left[5])
            ) {
                return { state: false, msg: "HearingLossDataRequired" };
            }

            if (!this.isDataRangeValid(this.state.left[2], 15, 120)){
                return { state: false, msg: "LeftHz500RangeRequired" };
            }

            if (!this.isDataRangeValid(this.state.left[4], 15, 120)){
                return { state: false, msg: "LeftHz2kRangeRequired" };
            }

            if (!this.isDataRangeValid(this.state.left[5], 15, 120)){
                return { state: false, msg: "LeftHz4kRangeRequired" };
            }
        }
        else if (this.state.leftRightOption === LeftRightOption.RightEarOption) {
            if (!this.idValidData(this.state.right[2]) ||
                !this.idValidData(this.state.right[3]) ||
                !this.idValidData(this.state.right[4]) ||
                !this.idValidData(this.state.right[5])
                ) {
                return { state: false, msg: "HearingLossDataRequired" };
            }     
            
            if (!this.isDataRangeValid(this.state.right[2], 15, 120)){
                return { state: false, msg: "RightHz500RangeRequired" };
            }

            if (!this.isDataRangeValid(this.state.right[4], 15, 120)){
                return { state: false, msg: "RightHz2kRangeRequired" };
            }

            if (!this.isDataRangeValid(this.state.right[5], 15, 120)){
                return { state: false, msg: "RightHz4kRangeRequired" };
            }
        }
        else {
            if (!this.idValidData(this.state.left[2]) ||
                !this.idValidData(this.state.left[3]) ||
                !this.idValidData(this.state.left[4]) ||
                !this.idValidData(this.state.left[5]) ||
                !this.idValidData(this.state.right[2]) ||
                !this.idValidData(this.state.right[3]) ||
                !this.idValidData(this.state.right[4]) ||
                !this.idValidData(this.state.right[5])
            ) {
                return { state: false, msg: "HearingLossDataRequired" };
            }

            if (!this.isDataRangeValid(this.state.left[2], 15, 120)){
                return { state: false, msg: "LeftHz500RangeRequired" };
            }

            if (!this.isDataRangeValid(this.state.left[4], 15, 120)){
                return { state: false, msg: "LeftHz2kRangeRequired" };
            }

            if (!this.isDataRangeValid(this.state.left[5], 15, 120)){
                return { state: false, msg: "LeftHz4kRangeRequired" };
            }

            if (!this.isDataRangeValid(this.state.right[2], 15, 120)){
                return { state: false, msg: "RightHz500RangeRequired" };
            }

            if (!this.isDataRangeValid(this.state.right[4], 15, 120)){
                return { state: false, msg: "RightHz2kRangeRequired" };
            }

            if (!this.isDataRangeValid(this.state.right[5], 15, 120)){
                return { state: false, msg: "RightHz4kRangeRequired" };
            }
        }
        
        return { state: true, msg: "validate success" };
    }

    idValidData(data) {
        if (!data) {
            return false;
        }

        let intdata = parseInt(data);
        if (intdata <= 0) {
            return false;
        }

        return true;
    }

    isDataRangeValid(data, min, max)
    {
        if (!data) {
            return false;
        }

        let intdata = parseInt(data);
        if (intdata < min || intdata > max) {
            return false;
        }

        return true;
    }


    render() {
        var isLeft = this.state.leftRightOption == LeftRightOption.LeftEarOption;
        var isRight = this.state.leftRightOption == LeftRightOption.RightEarOption;
        var disabledStyle = " bg-gray-200";
        return (
            <div className="flex flex-col w-1/2">
                <div className="p-1">
                    <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="HearingLossData" /><span className="text-red-500"><FormattedMessage id="HearingLossDataNoteSimple" /></span></label>
                    <table className="text-center w-full">
                        <tbody>
                            <tr className="">
                                <td><label className="self-center"></label></td>
                                <td><label className="self-center">125</label></td>
                                <td><label className="self-center">250</label></td>
                                <td><label className="self-center">500<span className="font-bold text-red-600">*</span></label></td>
                                <td><label className="self-center">1K<span className="font-bold text-red-600">*</span></label></td>
                                <td><label className="self-center">2K<span className="font-bold text-red-600">*</span></label></td>
                                <td><label className="self-center">4K<span className="font-bold text-red-600">*</span></label></td>
                                <td><label className="self-center">8K</label></td>
                            </tr>
                            <tr className="">
                                <td><label className="block text-sm font-medium text-gray-700 self-center mx-1"><FormattedMessage id="Left" /></label></td>
                                <td><BaseTextBox disabled={isRight ? "disabled" : ""} classnames={isRight ? disabledStyle : ""} type="number" step="10" min="0" name="left-0" value={this.state.left[0]} onChange={this.handleInputChange} /></td>
                                <td><BaseTextBox disabled={isRight ? "disabled" : ""} classnames={isRight ? disabledStyle : ""} type="number" step="10" min="0" name="left-1" value={this.state.left[1]} onChange={this.handleInputChange} /></td>
                                <td><BaseTextBox disabled={isRight ? "disabled" : ""} classnames={isRight ? disabledStyle : ""} type="number" step="10" min="0" name="left-2" value={this.state.left[2]} onChange={this.handleInputChange} /></td>
                                <td><BaseTextBox disabled={isRight ? "disabled" : ""} classnames={isRight ? disabledStyle : ""} type="number" step="10" min="0" name="left-3" value={this.state.left[3]} onChange={this.handleInputChange} /></td>
                                <td><BaseTextBox disabled={isRight ? "disabled" : ""} classnames={isRight ? disabledStyle : ""} type="number" step="10" min="0" name="left-4" value={this.state.left[4]} onChange={this.handleInputChange} /></td>
                                <td><BaseTextBox disabled={isRight ? "disabled" : ""} classnames={isRight ? disabledStyle : ""} type="number" step="10" min="0" name="left-5" value={this.state.left[5]} onChange={this.handleInputChange} /></td>
                                <td><BaseTextBox disabled={isRight ? "disabled" : ""} classnames={isRight ? disabledStyle : ""} type="number" step="10" min="0" name="left-6" value={this.state.left[6]} onChange={this.handleInputChange} /></td>
                            </tr>
                            <tr className="">
                                <td> <label className="block text-sm font-medium text-gray-700 self-center  mx-1"><FormattedMessage id="Right" /></label></td>
                                <td><BaseTextBox className="" disabled={isLeft ? "disabled" : ""} classnames={isLeft ? disabledStyle : ""} type="number" step="10" min="0" name="right-0" value={this.state.right[0]} onChange={this.handleInputChange} /></td>
                                <td><BaseTextBox disabled={isLeft ? "disabled" : ""} classnames={isLeft ? disabledStyle : ""} type="number" step="10" min="0" name="right-1" value={this.state.right[1]} onChange={this.handleInputChange} /></td>
                                <td><BaseTextBox disabled={isLeft ? "disabled" : ""} classnames={isLeft ? disabledStyle : ""} type="number" step="10" min="0" name="right-2" value={this.state.right[2]} onChange={this.handleInputChange} /></td>
                                <td><BaseTextBox disabled={isLeft ? "disabled" : ""} classnames={isLeft ? disabledStyle : ""} type="number" step="10" min="0" name="right-3" value={this.state.right[3]} onChange={this.handleInputChange} /></td>
                                <td><BaseTextBox disabled={isLeft ? "disabled" : ""} classnames={isLeft ? disabledStyle : ""} type="number" step="10" min="0" name="right-4" value={this.state.right[4]} onChange={this.handleInputChange} /></td>
                                <td><BaseTextBox disabled={isLeft ? "disabled" : ""} classnames={isLeft ? disabledStyle : ""} type="number" step="10" min="0" name="right-5" value={this.state.right[5]} onChange={this.handleInputChange} /></td>
                                <td><BaseTextBox disabled={isLeft ? "disabled" : ""} classnames={isLeft ? disabledStyle : ""} type="number" step="10" min="0" name="right-6" value={this.state.right[6]} onChange={this.handleInputChange} /></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="mt-1 p-1">
                    <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="SpecialRequirements" /></label>
                    <BaseTextArea classnames="mt-1 h-28" name="specialRequirements" value={this.state.specialRequirements ?? ""} onChange={this.handleTestAreaChange} />
                </div>
            </div>

        );
    }
}